export enum DocContentType {
  IMAGE = 'image',
  VIDEO = 'video',
  PDF = 'pdf',
  OTHER = 'other'
}

export type DocumentData = {
  documentRefId: string;
  uri: string;
  docContentType: string;
  documentType: string;
  documentName: string;
  dynamicallyGenerated: boolean;
};

export type DocumentType = {
  tabKey: string;
  tabName: string;
  documentsData: DocumentData[];
};

export enum ResourceType {
  DOCUMENTS = 'DOCUMENTS'
}
export interface AccessConsentGrantPayload {
  agentId: string;
  caseReferenceId: string;
  resourceType: string;
  entityId: string;
  businessVertical: string;
  reason: string;
  comments?: string;
}

export interface PIIForm {
  reason: string;
}
